export const ProtectGender=(gen)=>{
   if(gen==='F')
    return 'Female';
   else if(gen==='M')
    return 'Male';
    else
    return 'Transgender';
}